import { InputLabel, TextField } from "@mui/material";
import moment from "moment";
import { Grid } from "@mui/material";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { Autocomplete } from "@mui/lab";
import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useParams } from "react-router-dom";

import LoadingComponent from "../../../components/LoadingComponent";
import { getLayouts } from "../../../store/ducks/duckLayout";
import NavBar from "../../../components/Navbar";
import "../../../utils/chart";
import {
  getLayoutLog,
  getFilterLog,
  getMenuItemLog,
  getSourceLog,
  getTabLog,
} from "../../../store/ducks/duckLogger";

const Analytics = () => {
  const dispatch = useDispatch();
  const dataAnalytics = useSelector((state) => state?.analytics.data).sort((a, b) =>
    a.count < b.count ? 1 : -1,
  );
  const [resource, setResource] = useState("Tabs");
  const [user, setUser] = useState("personal");
  const { id } = useParams();
  const [firstRender, setFirstRender] = useState(true);

  const [until, setUntil] = useState(moment().format("yyyy-MM-DD"));
  const [since, setSince] = useState(moment(moment().subtract(1, "M")).format("yyyy-MM-DD"));

  //Primero verifica si le pasamos un id por useParams, despues si es un numero, si no lo
  // es, usa el metodo que nos retorna el id buscando por el pathname
  const [layoutId, setLayoutId] = useState(
    id ? (!isNaN(id) ? parseInt(id) : getIdCustomRoute(id)) : 0,
  );

  // Guarda la data traida del duck de layout y lo guarda en un array ordenado por el campo name
  const dataLayoutsArray = useSelector((state) => {
    let data = state.layout.dataLayout.sort((a, b) => (a.name > b.name ? 1 : -1));
    let dataL = [];

    data.forEach((x, index) => {
      dataL[index] = x;
    });

    return dataL;
  });

  // Retorna el label del layout dependiendo el id que se le pase
  const getDataLayoutsLabel = (Id) => {
    let dataL = dataLayoutsArray.find((x) => x.id === Id)?.name;

    return dataL;
  };

  //Retorna un id cuando el pathname del que clickean las analytics es custom como PRE o Annual
  function getIdCustomRoute(Pathname) {
    let dataL = dataLayoutsArray?.find((x) => x.name.includes(Pathname))?.id;

    return dataL;
  }

  // Lista de los id del array de layouts
  const getDataLayoutsId = () => dataLayoutsArray.map((x) => x.id);

  const isLoading = useSelector((state) => state.layout.isLoading);

  let tabFilterDTO = {
    id: 0,
    since: since,
    until: until,
    user: user,
    resourceId: layoutId,
  };

  let resourceDTO = {
    id: 0,
    since: since,
    until: until,
    user: user,
  };

  useEffect(() => {
    if (firstRender) {
      dispatch(getLayouts());
      setFirstRender(false);
    }

    switch (resource) {
      case "Sources":
        dispatch(getSourceLog(resourceDTO));
        break;
      case "MenuItems":
        dispatch(getMenuItemLog(resourceDTO));
        break;
      case "Layouts":
        dispatch(getLayoutLog(resourceDTO));
        break;
      case "Tabs":
        dispatch(getTabLog(tabFilterDTO));
        break;
      case "Filters":
        dispatch(getFilterLog(tabFilterDTO));
        break;
      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, since, until, resource, layoutId, user, id]);

  // const data = {
  //   labels: dataAnalytics.map((x) => x.name),
  //   datasets: [
  //     {
  //       label: "Visited",
  //       data: dataAnalytics.map((x) => x.count),
  //       backgroundColor: [
  //         "rgba(255, 99, 132, 0.2)",
  //         "rgba(54, 162, 235, 0.2)",
  //         "rgba(255, 206, 86, 0.2)",
  //         "rgba(75, 192, 192, 0.2)",
  //         "rgba(153, 102, 255, 0.2)",
  //         "rgba(255, 159, 64, 0.2)",
  //       ],
  //       borderColor: [
  //         "rgba(255, 99, 132, 1)",
  //         "rgba(54, 162, 235, 1)",
  //         "rgba(255, 206, 86, 1)",
  //         "rgba(75, 192, 192, 1)",
  //         "rgba(153, 102, 255, 1)",
  //         "rgba(255, 159, 64, 1)",
  //       ],
  //       borderWidth: 1,
  //     },
  //   ],
  // };

  // const options = {
  //   indexAxis: "y",
  //   // Elements options apply to all of the options unless overridden in a dataset
  //   // In this case, we are setting the border of each horizontal bar to be 2px wide
  //   elements: {
  //     bar: {
  //       borderWidth: 2,
  //     },
  //   },
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       position: "right",
  //     },
  //     title: {
  //       display: true,
  //       text: "Most Visited",
  //     },
  //   },
  // };
  const data = {
    labels: dataAnalytics.map((x) => x.name).reverse(),
    datasets: [
      {
        label: "Visited",
        data: dataAnalytics.map((x) => x.count).sort((a, b) => (a.count < b.count ? 1 : -1)),
        fill: false,
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "rgba(255, 99, 132, 0.2)",
      },
    ],
  };

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: false,
          },
        },
      ],
    },
  };

  return (
    <>
      {isLoading ? (
        <LoadingComponent loading={isLoading} />
      ) : (
        <>
          <NavBar />
          <div className="header">
            <h1 className="title">. .</h1>
          </div>
          <Grid
            container
            alignItems="center"
            direction="row"
            justify="center"
            style={{ marginBottom: 20 }}
            xs={12}
          >
            <Grid xs={1.5}>
              <InputLabel id="labelUser">Audience</InputLabel>
              <Select
                fullWidth
                defaultValue="personal"
                id="selectUser"
                labelId="labelUser"
                variant="outlined"
                onChange={(e) => setUser(e.target.value)}
              >
                <MenuItem value="personal">Personal</MenuItem>
                <MenuItem value="general">Global</MenuItem>
              </Select>
            </Grid>
            <Grid xs={1} />
            <Grid xs={1.5}>
              <InputLabel id="labelResource">Resource</InputLabel>
              <Select
                fullWidth
                defaultValue="Tabs"
                id="selectResource"
                labelId="labelResource"
                variant="outlined"
                onChange={(e) => setResource(e.target.value)}
              >
                <MenuItem value="Sources">Source</MenuItem>
                <MenuItem value="MenuItems">Menu Items</MenuItem>
                <MenuItem value="Layouts">Layouts</MenuItem>
                <MenuItem value="Tabs">Tabs</MenuItem>
                <MenuItem value="Filters">Filters</MenuItem>
              </Select>
            </Grid>
            <Grid xs={1} />
            {(resource === "Filters" || resource === "Tabs") && (
              <Grid xs={2}>
                <InputLabel id="autocompleteLabel">{resource} for Layouts</InputLabel>
                <Autocomplete
                  fullWidth
                  getOptionLabel={(option) => getDataLayoutsLabel(option)}
                  id="demo-Layouts"
                  labelId="autocompleteLabel"
                  options={getDataLayoutsId()}
                  renderInput={(params) => {
                    return <TextField {...params} key={`TextField Layouts-`} variant="outlined" />;
                  }}
                  value={
                    id ? (!isNaN(id) ? parseInt(id) : getIdCustomRoute(id)) : parseInt(layoutId)
                  }
                  onChange={(e, newValue) => setLayoutId(newValue ?? 0)}
                />
              </Grid>
            )}
            <Grid xs={1} />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Grid xs={2}>
                <InputLabel id="labelSince">Since</InputLabel>
                <DatePicker
                  format="MM/DD/YYYY"
                  label=""
                  slotProps={{ textField: { variant: "outlined" } }}
                  value={moment(since)}
                  onChange={(date) => setSince(moment(date).format("yyyy-MM-DD"))}
                />
              </Grid>
              <Grid xs={1} />
              <Grid xs={2}>
                <InputLabel id="labelUntil">Until</InputLabel>
                <DatePicker
                  format="MM/DD/YYYY"
                  label=""
                  maxDate={moment()}
                  slotProps={{ textField: { variant: "outlined" } }}
                  value={moment(until)}
                  onChange={(date) => setUntil(moment(date).format("yyyy-MM-DD"))}
                />
              </Grid>
            </LocalizationProvider>
          </Grid>

          <Line data={data} options={options} />
          {/* <Bar data={data} options={options} /> */}
        </>
      )}
      ;
    </>
  );
};

export default Analytics;
